export default __webpack_public_path__ + "static/media/MJN.e1759135.png";